
const langOptions = [ 
    { _id: 'fr', stringDisplayed: 'Français'},
    { _id: 'en-US', stringDisplayed: 'English'}, 
]; 

export default langOptions; 